import { SubscriptionExpirationBanner } from "@components/banners/subscription-expiration-banner";
import { TrialExpirationBanner } from "@components/banners/trial-expiration-banner";
import { WorkspaceSpecificBanner } from "@components/banners/workspace-specific-banner/workspace-specific-banner";
import { WORKSPACE_SPECIFIC_BANNERS } from "@components/banners/workspace-specific-banner/workspace-specific-banner-constants";
import { ResendVerification } from "@components/resend-verification";
import { ExceededSubscriptionLimitsBanner } from "@pages/settings/subscription-settings/exceeded-subscription-limits-banner";

/** List of all the banners to show to customer in the header */
export function BannersHeaderLayout(): JSX.Element {
  return (
    <>
      {/* Banners that show for specific workspaces */}
      {WORKSPACE_SPECIFIC_BANNERS.map((banner, index) => (
        <WorkspaceSpecificBanner key={index} {...banner} />
      ))}

      {/* Banner to remind users to verify email address */}
      <ResendVerification />

      {/* Trial expiration banner */}
      <TrialExpirationBanner />

      {/* Subscription expiration banner remind user to extend the subscription before loosing access */}
      <SubscriptionExpirationBanner />

      {/* Banner to show when a subscription limit is exceeded */}
      <ExceededSubscriptionLimitsBanner />
    </>
  );
}
